import { render, staticRenderFns } from "./tablaProductos.vue?vue&type=template&id=a6db54c6&"
import script from "./tablaProductos.vue?vue&type=script&lang=js&"
export * from "./tablaProductos.vue?vue&type=script&lang=js&"
import style0 from "./tablaProductos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports